import { createSlice } from '@reduxjs/toolkit';
import {} from './atsJobsActions';

// todo: need to remove once api is done
const reducerName = 'atsJobs';
const initialState = {
  searchTerm: null,
  filters: {
    office_ids: undefined,
    department_ids: [],
    job_statuses: undefined,
    user_ids: [],
    eeoc_data_collection: [],
    isFilterApplied: false,
    feConfig: [], // For new filter format
    beConfig: {}, // For backend config
  },
  page: {
    number: 0,
    offset: 0,
    limit: 20,
  },
  sort: {
    label: 'Created date (Newest to oldest)',
    value: 'DESC',
    element: 'created_at',
    order: 'DESC',
  },
  currentView: 'card',
  updateJob: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  createJob: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  getAllJobs: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  getAllDepartments: {
    isLoading: false,
    data: {},
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
  getAllOffices: {
    isLoading: false,
    data: [],
    status: undefined,
    errors: undefined,
    flash: undefined,
  },
};

const { reducer, actions: atsJobsActions } = createSlice({
  name: reducerName,
  initialState,

  reducers: {
    resetJobState: (state, { payload: { key } }) => {
      state[key] = { ...initialState[key] };
    },

    setCurrentView: (state, { payload: { view } }) => {
      state.currentView = view;
      // state.searchTerm = '';
    },

    applySort: (state, { payload }) => {
      state.sort = payload;
    },

    applyFilter: (state, { payload, ...props }) => {
      const { key, value, feConfig, beConfig, isNewFilter } = payload;

      // Handle new filter format
      if (isNewFilter) {
        if (feConfig) {
          state.filters.feConfig = feConfig;
        }
        if (beConfig) {
          state.filters.beConfig = beConfig;
        }
        state.filters.isFilterApplied = true;
        state.page = { ...initialState.page };
        return;
      }

      // Handle old filter format
      state.filters[key] = value;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    setFiltersData: (state, { payload }) => {
      state.filters.feConfig = payload;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = true;
    },

    applyFilters: (state, { payload, ...props }) => {
      for (let item of payload) {
        const { key, value } = item;
        state.filters[key] = value;
        state.page = { ...initialState.page };
        state.filters.isFilterApplied = true;
      }
    },

    applyPage: (state, { payload }) => {
      const { page } = payload;
      state.page.number = page;
      state.page.offset = state?.page?.number * state?.page?.limit;
      state.searchTerm = '';
    },

    clearFilter: (state, { payload }) => {
      const { key } = payload;
      state.filters[key] = initialState.filters[key];
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = Object.values(state.filters).some(
        (filter) => filter !== initialState.filters[key]
      );
    },

    clearAllFilter: (state) => {
      state.filters = { ...initialState.filters };
      state.filters.feConfig = [];
      state.filters.beConfig = {};
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = false;
    },

    clearData: (state) => {
      state.sort = { ...initialState.sort };
      state.currentView = initialState.currentView;
      state.searchTerm = '';
    },

    setLoadingState: (state, { payload }) => {
      const { key, isLoading } = payload || {};
      if (state[key]) {
        state[key].isLoading = isLoading;
      }
    },

    applySearch: (state, { payload }) => {
      state.searchTerm = payload?.searchTerm;
      state.page = { ...initialState.page };
      state.filters.isFilterApplied = payload?.searchTerm?.length > 0;
    },

    setApiData: (state, { payload = {} }) => {
      const { key, data, status, errors, isLoading, flash } = payload || {};
      if (state[key]) {
        state[key].data = data;
        state[key].isLoading = isLoading;
        state[key].status = status;
        state[key].flash = flash;
        state[key].errors = errors;
      }
    },
  },
});

export { atsJobsActions };
export default reducer;
